import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import LoadingIndicator from "../../../components/loadingIndicator/LoadingIndicator";
import {
  MOBILE_SCREEN_WIDTH,
  TAB_SCREEN_WIDTH,
} from "../../../utils/constants";
import { useMatchListStore } from "../../../store/StoreContext";
import { MatchCard } from "./MatchCard";
import { useFontDesk } from "../../../context/frontDeskContext";

type props = {};

export const AllMatchlist: React.FC<props> = observer(() => {
  const matchListStore = useMatchListStore();
  const { isMobile, isTab, setIsMobile, setIsTab } = useFontDesk();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_SCREEN_WIDTH);
      setIsTab(window.innerWidth < TAB_SCREEN_WIDTH && !isMobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, setIsMobile, setIsTab]);

  return (
    <>
      {matchListStore.matchList.length === 0 && !matchListStore.isLoading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ marginTop: 20 }}>
          <p className="text-center" style={{ fontSize: "1.2rem" }}>
            No matches found
          </p>
        </div>
      )}
      <div
        // ref={listRef}
        // onScroll={handleScroll}
        style={{
          marginTop: 20,
          display: isMobile ? "flex" : "grid",
          gridTemplateColumns: (() => {
            if (isMobile) return "1fr";
            if (isTab) return "repeat(1, 1fr)";
            // desktop
            return matchListStore.matchList.length === 1
              ? "1fr"
              : "repeat(2, 1fr)";
          })(),
          gap: isMobile ? "25px" : "25px 25px", // row-gap 15px, column-gap 25px for desktop
          flexDirection: isMobile ? "column" : undefined,
          padding: "0 16px",
          width: "100%",
          overflowY: "auto",
        }}>
        {matchListStore.matchList.map((match, idx) => {
          const isSingleCentered =
            !isMobile && matchListStore.matchList.length === 1;
          return (
            <div
              key={match.id}
              style={{
                maxWidth: isSingleCentered ? 800 : "100%",
                margin: isSingleCentered ? "0 auto" : undefined,
                width: "100%",
              }}>
              <MatchCard match={match} />
            </div>
          );
        })}
      </div>
      <LoadingIndicator loading={matchListStore.isLoading} />
    </>
  );
});
